/* eslint-disable react/prop-types */
import hasPermission from "@/hooks/hasPermission";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { Outlet, Navigate } from "react-router-dom";

function Permission({keyName}){
    const permission = hasPermission(keyName);
    console.log("permission", permission, keyName)

    useEffect(() => { 
        if (!permission) {
            toast.error("You do not have permission!", { id: "permission-error" });
        }
    }, [permission]);

    return(permission ? <Outlet /> : <Navigate to="/access-denied" replace />);
}


export default Permission;